import React, { useEffect, useRef, useState } from "react";
import { Loader, SubmitBar } from "@egovernments/digit-ui-react-components";
import { Row, Col,Card, Container } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
// import { Link, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import FormatSlip from "./FormatSlip";
import { ToWords } from 'to-words';

const PaymentPrint = ({id}) => {
  // const { id } = useParams();
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords();
  const [loader, setLoader] = useState(false);
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = Digit.UserService.getUser()?.info || {};
  const getApplicationPay = async () => {
    setLoader(true);
    const token = window?.localStorage?.getItem("token");

    let requestInfo = {
      "RequestInfo": {
        "apiId": "Rainmaker",
        "ver": "v1",
        "ts": 0,
        "action": "_search",
        "did": "",
        "key": "",
        "msgId": "090909",
        "requesterId": "",
        authToken: token,
        userInfo: userInfo,
      }

    }
    try {
      const Resp = await axios.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then((response) => {
        return response?.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp?.Transaction?.[0]);
      const amountPaid = Resp?.Transaction?.[0]?.additionalDetails?.taxAndPayments[0]?.amountPaid;
      if (amountPaid) {
        const wordsList = toWords.convert(amountPaid, { currency: true, ignoreDecimal: false });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      }

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicationPay("");
  }, [id]);
  const { data : applicationData ={} , isLoading:paymentStatus } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id }, { formType:"form11" });
  const business_service = applicationData?.businessService
  const { eg_pg_txnid: egId, txnStatus: txn, workflow: workflw } = Digit.Hooks.useQueryParams();
  const { isLoading : paymentLoading , data, isError } = Digit.Hooks.usePaymentUpdate({ egId, txn }, business_service, {
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
  if(loader || paymentStatus ){
    return <Loader />
  }
  
  return (

    <Container
      className="justify-content-center"
      style={{
        minWidth: "100%",
        maxWidth: "100%",
        maxHeight: "50%",
        minHeight: "40%",
        marginTop: 5,
      }}
    >
      <Card>

        <div ref={conponentPDF}>
          <div>
            <FormatSlip
              scrutinyTable={scrutinyTable}
              scrutinyDetails={applicationData}
              wordslist={amountDetails}
            />
          </div>
        </div>

        {/* <Row className="justify-content-space-between" style={{ padding: "10px",marginTop:20 }}>
          <Col xs="4">
          <Link to={`/digit-ui/citizen/profile`}>
      <SubmitBar style={{marginLeft:"85px"}} label={t("CORE_COMMON_GO_TO_HOME")} />
      </Link>
          </Col>
          <Col xs="4"></Col>
         <Col xs="4">
         <ReactToPrint
                trigger={() => <button class="btn btn-success" id="invoice-print">Print Payment Receipt</button>}
                content={() => conponentPDF.current}
              />
         </Col>
         
          </Row> */}

      </Card>


    </Container>
  );
};

export default PaymentPrint;




